import Hero from "@/components/sections/Hero";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import Services from "@/components/sections/Services";
import DomainSearch from "@/components/sections/DomainSearch";
import WhyUs from "@/components/sections/WhyUs";
import Process from "@/components/sections/Process";
import OurWork from "@/components/sections/OurWork";
import Industries from "@/components/sections/Industries";
import Manifesto from "@/components/sections/Manifesto";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Insights from "@/components/sections/Insights";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <SEO {...SEO_MAP.home} />
      <Hero />
      <EditorialMarquee />
      <Services />
      <DomainSearch />
      <Manifesto />
      <WhyUs />
      <Process />
      <OurWork />
      <Industries />
      <Testimonials />
      <FAQ />
      <Insights />
    </main>
  );
}
